import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPasswordService } from '../../services/authService';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Por favor, ingresa tu email');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      
      await forgotPasswordService(email);
      
      setMessage('Hemos enviado un correo con instrucciones para restablecer tu contraseña');
      setEmail('');
    } catch (error) {
      setError('No se pudo procesar la solicitud. Verifica que el email sea correcto.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h2>Recuperar Contraseña</h2>
        
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Ingresa tu email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Instrucciones'}
          </button>
        </form>
        
        <div className="back-to-login">
          <Link to="/login">Volver al inicio de sesión</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;